// extracted by mini-css-extract-plugin
export default {"selected":"Gallery_selected__G1zqe","imgContainer":"Gallery_imgContainer__MMpmq"};